<template>
  <div
    v-if="participants.length !== 0"
    class="participants">
    {{ label }}
    <span
      v-for="(participant, index) in participants"
      :key="index"
      class="participant">
      <a
        :href="searchUrl + participant"
        :title="participant"
        rel="noopener"
        target="_blank"
        data-wptv="participant">
        {{ participant }}
      </a>
    </span>
  </div>
</template>

<script>
import _get from 'lodash/get'

export default {
  name: 'CategoryParticipants',
  props: {
    label: {
      type: String,
      required: true
    },
    participants: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    searchUrl () {
      return _get(this.$config, 'confetti.public.urls.searchUrl')
    }
  }
}
</script>

<style lang="scss" scoped>
  .participants {
    display: flex;
    flex-wrap: wrap;

    .participant {
      display: inline-flex;
      margin-right: 5px;

      &:first-child {
        margin-left: 5px;
      }

      &:not(:last-child) {
        &:after {
          content: ',';
        }
      }

      a {
        color: inherit;

        &:hover {
          text-decoration: underline $primary;
          text-shadow: 1px 0 0; // using bold font is bad because width "jumps" on hover
        }
      }
  }
}
</style>
